module.exports = __webpack_public_path__ + "static/img/tx.3534f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tx.png
// module id = a6V4
// module chunks = 1